import React from "react";
import PropTypes from "prop-types";

function VoiceIndicator({ size, bgColor }) {
  return <div
      className="rounded-full transition-all"
      style={{ width: size, height: size, backgroundColor: bgColor }}
  />
}

VoiceIndicator.propTypes = {
  value: PropTypes.number,
};

export default VoiceIndicator;
